<template>
  <div>
    <h1>Registration Users</h1>
    <br>

    <v-card class="mb-4">
      <v-card-title class="card-title">
        <span class="headline white--text text-uppercase">Search Registrar</span>
      </v-card-title>

      <v-card-text>
        <v-layout row>
          <v-flex mr-2>
            <v-text-field
              v-model="search"
              box
              :loading="loading"
              hide-details
              label="Email"
            />
          </v-flex>
          <v-flex
            xs2
            ml-2
          >
            <v-btn
              block
              large
              @click="searchEmail"
            >
              Find
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title class="card-title">
        <span class="headline white--text text-uppercase">
          Registrar
        </span>
      </v-card-title>
      <v-card-text v-if="registrar !== null">
        <v-text-field
          v-model="registrar.email"
          readonly
          label="Email"
        />

        <v-layout row>
          <v-flex class="mr-2">
            <v-text-field
              v-model="registrar.firstName"
              readonly
              label="First name"
            />
          </v-flex>
          <v-flex class="ml-2">
            <v-text-field
              v-model="registrar.lastName"
              readonly
              label="Last name"
            />
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex class="mr-2">
            <v-text-field
              v-model="registrar.soiAt"
              readonly
              label="SOI date"
            />
          </v-flex>
          <v-flex class="ml-2">
            <v-text-field
              v-model="registrar.doiAt"
              readonly
              label="DOI date"
            />
          </v-flex>
        </v-layout>

        <v-text-field
          v-model="registrar.completedAt"
          readonly
          label="Completion date"
        />

        <v-text-field
          v-model="registrar.phone"
          readonly
          label="Phone"
        />
        <v-text-field
          v-model="registrar.origin"
          readonly
          label="Origin"
        />

        <v-layout row>
          <v-flex class="mr-2">
            <v-text-field
              v-model="registrar.affiliateId"
              readonly
              label="Affiliate ID"
            />
          </v-flex>
          <v-flex class="ml-2">
            <v-text-field
              v-model="registrar.friendId"
              readonly
              label="Friend ID"
            />
          </v-flex>
        </v-layout>

        <v-text-field
          v-model="registrar.id"
          readonly
          label="Registration ID"
          class="mt-4 "
        />

        <v-btn
          :disabled="registrar.status !== 'soi'"
          block
          class="mt-4 ma-0 pl-2"
          color="error"
          @click="deleteModalOpen = true"
        >
          <v-icon>delete</v-icon>
          Delete
        </v-btn>
      </v-card-text>
      <v-card-text v-else>
        No registrar found
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="deleteModalOpen"
      width="400"
      persistent
    >
      <v-card v-if="registrar">
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Delete Registration
        </v-card-title>

        <v-card-text>
          <div>Do you want to delete {{ registrar.email }}?</div>
          <div class="mt-2">
            This will also stop the user from receiving emails.
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            flat
            @click="deleteModalOpen = false"
          >
            Close
          </v-btn>
          <v-btn
            flat
            color="alert"
            :loading="loading"
            @click="deleteRegistrar"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { mapActions } from 'vuex';

export default {
  name: 'Registrations',
  components: {},
  data() {
    return {
      deleteModalOpen: false,
      search: '',
      registrar: null,
      loading: false,
    };
  },
  methods: {
    ...mapActions(['searchRegistration', 'deleteRegistration']),
    searchEmail() {
      this.loading = true;

      this.searchRegistration({
        email: this.search,
      })
        .then((item) => {
          this.registrar = item;
        }, () => {
          this.registrar = null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteRegistrar() {
      if (!this.registrar) {
        return;
      }

      this.loading = true;

      this.deleteRegistration({
        email: this.registrar.email,
      })
        .then(() => {
          this.registrar = null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/registrations/Registrations.vue